import { Button } from "primereact/button";
import DownloadApplicationSection from "../Components/downloadApplicationSection";
import RequestDemoSection from "../Components/requestDemoSection";

const Individuals = () => {

    const features = [
        {
            src: "/AILogo.png",
            title: "Real-Time AI Feedback",
            desc: "Get instant posture correction and movement analysis during every exercise. Mobithera’s AI helps you perform with confidence and precision."
        },
        {
            src: "/Shapes.png",
            title: "Engaging & Interactive Experience",
            desc: "Track your progress, complete movement goals, and stay motivated with visual achievements and gamified elements, all tailored to your therapy."
        },
        {
            src: "/VideoPlayer.png",
            title: "Video-Guided Exercises",
            desc: "Follow expertly designed videos that demonstrate how to perform each exercise correctly, ensuring safety and clarity at every step."
        }
    ]

    return (
        <>
            <div style={{
                width: "100%",
                backgroundImage: "url('/For-Individuals.jpg')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
            }} className="flex flex-column justify-content-center gap-5 px-4 md:px-8 py-8" >
                <p className="m-0 text-left" style={{ color: "#29345E", lineHeight: "4rem", fontSize: "3.25rem", fontWeight: 700, wordBreak: "break-word" }} >
                    Personalized <br /> Therapy In Your <br /> Pocket
                </p>
                <p className="m-0 text-xl text-left md:w-30rem" style={{ color: "#727A99"}}>
                    Recover faster with clinically approved exercises, guided by our powerful artificial intelligence. Improve your strength, flexibility, and movement quality
                </p>
                <Button label="Get in touch" iconPos="right"
                    className="text-lg"
                    icon="pi pi-angle-right"
                    style={{
                        color: "white",
                        fontWeight: 700,
                        backgroundColor: "#E3506B",
                        borderRadius: "10px",
                        height: "3.5rem",
                        width: "15rem"
                    }} />
            </div>
            <div style={{
                width: "100%",
                minHeight: "100vh",
                backgroundImage: "url('/RequestDemoBackground.png')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }} className="flex flex-column justify-content-center align-items-center gap-6 px-4 md:px-8 py-8" >
                <p className="m-0 text-xl" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >FEATURES</p>
                <p className="flex flex-wrap justify-content-center align-items-center m-0 text-center" style={{ color: "white", fontSize: "3.25rem", fontWeight: 700 }}>
                    Stronger Steps Start With <span className="flex mx-3 align-items-center gap-1" style={{color: "#E3506B"}}>Mobithera<span style={{fontSize: "1.25rem", marginTop: "-0.5rem"}}>™</span></span>
                </p>
                <p className="text-xl m-0 text-center" style={{color: "#EAEBF0"}}>
                    Your recovery journey deserves the best. Explore features designed to empower <br />
                    your progress, every movement, every moment.
                </p>
                <div className="flex flex-wrap gap-5 justify-content-between py-8" style={{ width: "100%" }}>
                    {features.map((feature) => (
                        <div className="flex flex-column bg-white justify-content-center align-items-center gap-4 px-4 py-8 flex-grow-1" style={{ width: "25rem" }}>
                            <img src={feature.src} alt={feature.title} key={feature.title} width={30} />
                            <p className="m-0 text-center font-bold" style={{ color: "#2D3967", fontSize: "1.25rem"}}>
                                {feature.title}
                            </p>
                            <p className="m-0 text-center text-lg" style={{ color: "#727A99"}}>
                                {feature.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
            {/*  Goals */}
            <div className="flex flex-wrap justify-content-center xl:justify-content-evenly align-items-center py-5 px-4 md:px-8" style={{backgroundColor: "#F5F5F5"}}>
                <div className="flex flex-column justify-content-center align-items-start gap-4 xl:w-30rem flex-grow-1" >
                    <p className="m-0 text-xl" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >GOALS</p>
                    <p className="m-0 font-bold" style={{ color: "#2D3967", fontSize: "3.25rem", fontWeight: 700, wordBreak: "break-word" }} >
                        Personalized Exercise Plans
                    </p>
                    <p className="m-0 text-xl" style={{ color: "#727A99", textWrap: "wrap" }} >
                        Mobithera delivers exercise programs tailored
                        to your individual needs and medical goals.
                        Every plan is created by your clinician to
                        ensure safe, effective rehabilitation that’s
                        fully customized for you.
                    </p>
                </div>
                <img src="/Goals.jpg" className="w-30rem flex-grow-1" />
            </div>
            {/*  Goals - 2 */}
            <div className="flex flex-wrap justify-content-center xl:justify-content-evenly align-items-center py-5 px-4 md:px-8" style={{backgroundColor: "#F5F5F5"}}>
                <img src="/Goals-2.jpg" className="w-30rem flex-grow-1" />
                <div className="flex flex-column justify-content-center align-items-start gap-4 xl:w-30rem flex-grow-1" >
                    <p className="m-0 text-xl" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >GOALS</p>
                    <p className="m-0 font-bold" style={{ color: "#2D3967", fontSize: "3.25rem", fontWeight: 700, wordBreak: "break-word" }} >
                        Real-Time Feedbacks & Movement Correction
                    </p>
                    <p className="m-0 text-xl" style={{ color: "#727A99", textWrap: "wrap" }} >
                        Receive instant feedback during exercises
                        through AI-powered motion tracking.
                        Mobithera helps you stay on track by
                        identifying incorrect movements and guiding
                        you toward safe, proper form. Faster recovery, fewer mistakes.
                    </p>
                </div>
            </div>
            <RequestDemoSection />
            {/*  Applications */}
            <DownloadApplicationSection />
        </>
    )
}

export default Individuals;